import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, of, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/modules/auth/_services/auth.service';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { ForgetPasswordComponent } from '../forget-password/forget-password.component';

@Component({
  selector: 'app-staff-login',
  templateUrl: './staff-login.component.html',
  styleUrls: ['./staff-login.component.scss']
})
export class StaffLoginComponent implements OnInit, OnDestroy {
  defaultAuth: any = {
    personalNo: '',
    password: '',
  };
  language: any;
  hasError: boolean;
  ErrorMessage: string;
  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  loginForm: UntypedFormGroup;
  isLoading$: Observable<boolean>;

  constructor(private translationService: TranslationService,
    private authService: AuthService,
    private router: Router,
    private modalService: NgbModal,
    private fb: UntypedFormBuilder,
  ) {
    this.isLoading$ = this.authService.isLoading$;
     if (localStorage.getItem("v1Balsam-authf649ei9a5f55")) {
        this.router.navigate(['/portal/dashboard']);
    }
  }

  ngOnInit(): void {
    this.language = this.translationService.getSelectedLanguage();
    this.initForm();
  }
  get f() {
    return this.loginForm.controls;
  }
  initForm() {
    this.loginForm = this.fb.group({
      personalNo: [this.defaultAuth.personalNo, Validators.required],
      password: [this.defaultAuth.password, Validators.required]
    });
  }
  submit() {
    this.loginForm.markAllAsTouched();
    if (!this.loginForm.valid) {
      return;
    }
    this.hasError = false;
    const loginSubscr = this.authService.Stafflogin(this.f.personalNo.value, this.f.password.value).subscribe(res => {
      
      if (res.userId && res.userId != 0 && res.userId != null) {
       this.router.navigate(['/portal/dashboard']);
       this.authService.hideLoader();
      }
      else if (!res.error?.isSuccess && res.error.responseCode == 404) {
        this.ErrorMessage = res.error?.message
        this.hasError = true;
      }
      else if (!res.error.isSuccess && res.error.responseCode == 500) {
        if (this.language == "ar") {
          this.ErrorMessage = "حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا";
        }
        else {
          this.ErrorMessage = "Something went wrong, try again later, please";
        }
        this.hasError = true;
      }
      else {
        if (this.language == "ar") {
          this.ErrorMessage = "اسم المستخدم أو كلمة المرور غير صحيحة";
        }
        else {
          this.ErrorMessage = "Username or Password is incorrect";
        }
        this.hasError = true;
      }
    });
    this.unsubscribe.push(loginSubscr);
  }
  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
  // helpers for View
  isControlValid(controlName: string, FormGroup: UntypedFormGroup): boolean {
    const control = FormGroup.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }
  isControlInvalid(controlName: string, FormGroup: UntypedFormGroup): boolean {
    const control = FormGroup.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }
  controlHasError(validation: string, controlName: string, FormGroup: UntypedFormGroup) {
    const control = FormGroup.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }
  isControlTouched(controlName: string, FormGroup: UntypedFormGroup): boolean {
    const control = FormGroup.controls[controlName];
    return control.dirty || control.touched;
  }
}
